import { render, staticRenderFns } from "./FooterTopComponent.vue?vue&type=template&id=88bc89c6&lang=pug&"
import script from "./FooterTopComponent.vue?vue&type=script&lang=js&"
export * from "./FooterTopComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports